import { render } from "./account_actions.vue?vue&type=template&id=a006454a"
import script from "./account_actions.js?vue&type=script&lang=js"
export * from "./account_actions.js?vue&type=script&lang=js"

import "./account_actions.vue?vue&type=style&index=0&id=a006454a&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__